/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/bookmark/api-local',['require','underscore','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var LocalStorage = Marionette.Controller.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    namespace: 'bm',

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ////console.log('LocalStorage::initialize');
      console.warn('Bookmarking Solution: LocalStorage');
    },

  /*****************************************************************************************************************///}

  /////////
  // API /{
  /////////

    setComplete: function(options)
    {
      this.setStatus('complete');
    },

    getLocation: function()
    {
      var $value;
      try {
        $value = window.localStorage[_.result(this, 'namespace') + '.location'];
      }
      catch (_err) {
        console.log('Local storage unavailable.');
        $value = null;
      }
      return $value || null;
    },

    setLocation: function(value)
    {
      try {
        window.localStorage[_.result(this, 'namespace') + '.location'] = value;
      }
      catch (_err) {
        console.log('Local storage unavailable.');
      }
    },

    getDatachunk: function()
    {
      var $value;
      try {
        $value = window.localStorage[_.result(this, 'namespace') + '.datachunk'];
      }
      catch (_err) {
        console.log('Local storage unavailable.');
        $value = null;
      }
      return $value || null;
    },

    setDatachunk: function(value)
    {
      try {
        window.localStorage[_.result(this, 'namespace') + '.datachunk'] = value;
      }
      catch (_err) {
        console.log('Local storage unavailable.');
      }
    },

    getStatus: function()
    {
      var $value;
      try {
        $value = window.localStorage[_.result(this, 'namespace') + '.status'];
      }
      catch (_err) {
        console.log('Local storage unavailable.');
        $value = null;
      }
      return $value || null;
    },

    setStatus: function(value)
    {
      try {
        window.localStorage[_.result(this, 'namespace') + '.status'] = value;
      }
      catch (_err) {
        console.log('Local storage unavailable.');
      }
    },

    getScore: function()
    {
      var $value;
      try {
        $value = window.localStorage[_.result(this, 'namespace') + '.score'];
      }
      catch (_err) {
        console.log('Local storage unavailable.');
        $value = null;
      }
      return $value || null;
    },

    setScore: function(value)
    {
      try {
        window.localStorage[_.result(this, 'namespace') + '.score'] = value;
      }
      catch (_err) {
        console.log('Local storage unavailable.');
      }
    },

    getStudentName: function()
    {
      return 'no, name';//window.localStorage[_.result(this, 'namespace') + '.studentname'];
    },

    getStudentID: function()
    {
      return 'nolocalid';//window.localStorage[_.result(this, 'namespace') + '.studentid'];
    }

  /*****************************************************************************************************************///}

  });

  return LocalStorage;

});

